import React, { useState } from 'react';
import PropTypes, { arrayOf } from 'prop-types';
import Menu from './Menu.component';
import bem from '../../_utils/bem';

var MenuItem = function MenuItem(_ref) {
  var title = _ref.title,
      url = _ref.url,
      sublinks = _ref.sublinks,
      _ref$block = _ref.block,
      block = _ref$block === void 0 ? 'menu' : _ref$block,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? [] : _ref$modifiers;

  var _useState = useState(false),
      isExpanded = _useState[0],
      setExpanded = _useState[1];

  var toggleExpanded = function toggleExpanded() {
    return setExpanded(!isExpanded);
  };

  var expandedModifiers = isExpanded ? ['open'] : [];
  var submenuModifiers = isExpanded ? ['sub-open'] : [];
  var mods = [].concat(modifiers, sublinks ? ['with-sub'] : []);
  return /*#__PURE__*/React.createElement("li", {
    className: bem(block, 'item', mods)
  }, /*#__PURE__*/React.createElement("a", {
    className: bem(block, 'link', mods),
    href: url
  }, title), sublinks && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: bem('expand-sub', '', expandedModifiers),
    onClick: toggleExpanded
  }), /*#__PURE__*/React.createElement(Menu, {
    block: block,
    level: 1,
    items: sublinks,
    modifiers: submenuModifiers
  })));
}; // Defines the menu item shape and then recursively adds the shape to itself as
// an array of sublinks. Export this shape for other components to use.


var menuItemShape = {
  title: PropTypes.string,
  url: PropTypes.string,
  block: PropTypes.string,
  modifiers: arrayOf(PropTypes.string)
};
menuItemShape.sublinks = PropTypes.arrayOf(PropTypes.shape(menuItemShape));
export var menuItemPropType = menuItemShape;
export default MenuItem;